import React from "react";
import PendingButton from "components/common/PendingButton";

export const SaveButton = ({ onClick, children = "Back", ...props }) => (
  <PendingButton color="secondary" outline onClick={onClick} {...props}>
    {children}
  </PendingButton>
);

export default SaveButton;
